import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomerAreaContainerComponent } from '../../containers/customer-area-container/customer-area-container.component';
import { BillsListComponent } from './components/bills-list/bills-list.component';
import { TokenLocalStorageService } from '../authentication/services/token-local-storage.service';

const routes: Routes = [
  {
    path: '', component: CustomerAreaContainerComponent,
    children: [
      { path: 'factures', canActivate: [TokenLocalStorageService], children: [
          { path: '', component: BillsListComponent },
          { path: ':tab/:procedure', pathMatch: 'full', component: BillsListComponent },
          { path: ':tab', component: BillsListComponent },
        ]
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BillsRoutingModule { }
